import { faMoneyBill, faMoneyBillTransfer } from '@fortawesome/free-solid-svg-icons';

export const PAYMENT_METHODS = [
  {
    id: 'pagofacil',
    label: 'Pago Fácil',
    icon: faMoneyBill,
    logoSrc: '/assets/images/payment-methods/pago-facil.png',
  },
  {
    id: 'mercadopago',
    label: 'MercadoPago',
    icon: faMoneyBillTransfer,
    logoSrc: '/assets/images/payment-methods/mercado-pago.png',
  },
  {
    id: 'cobroexpress',
    label: 'Cobro Express',
    icon: faMoneyBillTransfer,
    logoSrc: '/assets/images/payment-methods/cobro-express.png',
  },
  {
    id: 'transferencia',
    label: 'Transferencia',
    icon: faMoneyBillTransfer,
  },
];

export const PRIMARY_PAYMENT_METHODS_COUNT = 3;
